import s from './DetailSection.module.scss'
import { FC, useEffect, useRef, useState } from 'react'
import {
  Text,
  CustomImage,
  Container,
  Button,
  VideoPlayer,
} from '@components/ui'

import { BigPlayButton, ControlBar, Player, PlayerReference } from 'video-react'
import { LoreThreeDetailPageSectionsInner } from '@generated/model/loreThreeDetailPageSectionsInner'
import DetailDropdowns from './DetailDropdowns'
import { CustomImageProps } from '@components/ui/CustomImage/CustomImage'
import { ProductSlider } from '@components/product'

type DetailSectionProps = {
  section: LoreThreeDetailPageSectionsInner
}

const DetailSection: FC<DetailSectionProps> = ({ section }) => {
  const [activeDropDown, setActiveDropDown] = useState<number | null>(null)

  const handleSetActiveDropdown = (index: number) => {
    if (section.dropdowns?.[index] && section.dropdowns[index].image)
      setActiveDropDown(index)
  }

  return (
    <>
      <section className={s.root}>
        <Container>
          <div className={s.grid}>
            {section.title && (
              <Text className={s.title} variant="contentHeading">
                {section.title}
              </Text>
            )}

            {section.detail && (
              <Text className={s.detail} html={section.detail} />
            )}

            {(section.video || section.video_url) && (
              <VideoPlayer
                data={section}
                controls={section.controls}
                className={s.videoContainer}
              />
            )}

            {section.dropdowns && section.dropdowns.length > 0 && (
              <div className={s.dropdownContainer}>
                <DetailDropdowns
                  dropdowns={section.dropdowns}
                  handleSetActiveDropdown={handleSetActiveDropdown}
                />
              </div>
            )}

            {section.dropdowns &&
              section.dropdowns.length > 0 &&
              section.dropdowns.some((dropdown) => dropdown.image) && (
                <div className={s.image}>
                  <ProductSlider
                    disabledOnDesktop={false}
                    currentSlide={activeDropDown ?? 0}
                    showNavigation={false}
                    perView={1}
                    spacing={20}
                    className={s.slider}
                    childClassName={s.blocks}
                    mobileProps={{
                      slides: {
                        spacing: 10,
                      },
                    }}
                  >
                    {section.dropdowns.map((dropdown) => (
                      <div className={s.galleryImage} key={dropdown.id}>
                        <CustomImage
                          data={dropdown as unknown as CustomImageProps}
                          layout="responsive"
                        />
                      </div>
                    ))}

                    <></>
                  </ProductSlider>
                </div>
              )}
          </div>
        </Container>
      </section>
    </>
  )
}

export default DetailSection
